import { saveFilterSettings as saveFilterSettingsDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type Props = ApiMethodBase & {}

export const saveFilterSettings = ({
    eventEmitter,
}: Props) => {
    saveFilterSettingsDiagram();
};
